import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const ChevronMiniFullUpIcon = (props: IconProps) => (
  <Icon
    viewBox="0 0 16 16"
    fill="currentColor"
    title={t`Chevron Mini Full Up`}
    {...props}
  >
    <Path
      fill="currentColor"
      d="m8.354 6.354 2.792 2.792a.5.5 0 0 1-.353.854H5.207a.5.5 0 0 1-.353-.854l2.792-2.792a.5.5 0 0 1 .708 0Z"
    />
  </Icon>
);
